import React, { useContext } from "react";
import { Measurements } from "./measurements";
import { MeasurementsBox } from "./measurement-box";

import { AttributesContext } from "contexts/attributes";
import { lookupUUID } from "shared/attribute-uuid";
import "./measurements.scss";

const uomDisplay = (value) => {
    return value && value.text ? value.text : "";
};

export const MeasurementsDetails = ({ showBox = false, showCalculatedWeight = false }) => {
    const { data } = useContext(AttributesContext);
    const imperialWidth = data[lookupUUID("width")];
    const metricWidth = data[lookupUUID("metricWidth")];
    const gs1PackageType = data[lookupUUID("gs1PackageType")];
    const hasImperial = imperialWidth || (Number.isInteger(imperialWidth) && imperialWidth !== 0);
    const hasMetric = metricWidth || (Number.isInteger(metricWidth) && metricWidth !== 0);

    //Imperial
    const dimensions = Object.fromEntries(
        Object.entries({
            width: imperialWidth || 0,
            height: data[lookupUUID("height")] || 0,
            depth: data[lookupUUID("depth")] || 0,
            weight: data[lookupUUID("weight")] || 0,
        }).sort((a, b) => b[1] - a[1])
    );

    const uom = {
        width: uomDisplay(data[lookupUUID("packageWidthUOM")]),
        height: uomDisplay(data[lookupUUID("packageHeightUOM")]),
        depth: uomDisplay(data[lookupUUID("packageDepthUOM")]),
        weight: uomDisplay(data[lookupUUID("packageWeightUOM")]),
    };

    //Metric
    const metricDimensions = Object.fromEntries(
        Object.entries({
            width: metricWidth || 0,
            height: data[lookupUUID("metricHeight")] || 0,
            depth: data[lookupUUID("metricDepth")] || 0,
            weight: data[lookupUUID("metricWeight")] || 0,
        }).sort((a, b) => b[1] - a[1])
    );

    const metricUom = {
        width: uomDisplay(data[lookupUUID("metricWidthUOM")]),
        height: uomDisplay(data[lookupUUID("metricHeightUOM")]),
        depth: uomDisplay(data[lookupUUID("metricDepthUOM")]),
        weight: uomDisplay(data[lookupUUID("metricWeightUOM")]),
    };

    const packageType = gs1PackageType ? gs1PackageType.code : "";

    if (!hasMetric && !hasImperial) {
        return null;
    }

    if (showBox) {
        return (
            <div>
                {hasImperial && (
                    <MeasurementsBox
                        dimensions={dimensions}
                        uom={uom}
                        label="Imperial"
                    />
                )}
                {hasMetric && (
                    <MeasurementsBox
                        dimensions={metricDimensions}
                        uom={metricUom}
                        label="Metric"
                    />
                )}
            </div>
        );
    }

    return (
        <>
            {
                <div className="measurements-details">
                    {hasImperial && (
                        <div>
                            <Measurements
                                dimensions={dimensions}
                                uom={uom}
                                packageType={packageType}
                                showCalculatedWeight={showCalculatedWeight}
                            />
                        </div>
                    )}
                    {hasMetric && (
                        <div>
                            <Measurements
                                dimensions={metricDimensions}
                                uom={metricUom}
                                packageType={packageType}
                                showCalculatedWeight={showCalculatedWeight}
                            />
                        </div>
                    )}
                </div>
            }
        </>
    );
};
